import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

import apiHandler from "../common/api";
import { ArrowRight } from "feather-icons-react/build/IconComponents";
import AddTeam from "../../feature-module/Modules/Business/AddTeam";
import AddService from "../../feature-module/Modules/Service/AddService";
import { isValidAustralianPhoneNumber } from "../../feature-module/common/common";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import LoadingSpinner from "../../InitialPage/Sidebar/LoadingSpinner";
import { TeamData } from "../../core/json/Team_Data";
import { setTeamValue } from "../../core/redux/action";
import ServiceMenuModal from "../../core/modals/applications/ServicemenuModal";
// import CountUp from "react-countup";
// import {
//   File,
//   User,
//   UserCheck,
// } from "feather-icons-react/build/IconComponents";
// import Chart from "react-apexcharts";
// import { Link } from "react-router-dom";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
// import { ArrowRight } from "react-feather";
import { all_routes } from "../../Router/all_routes";
// import withReactContent from "sweetalert2-react-content";
// import Swal from "sweetalert2";
// import { useSelector } from "react-redux";

const Dashboard = () => {
  const userData = useSelector((state) => state.user_data);
  const isSuperAdmin = userData?.roleName === "Super Admin";
  const isAdmin = userData?.roleID === 1 || userData?.roleName === "Business Admin" || isSuperAdmin;
  const defaultStart = moment().subtract(2, "months").toDate();
  const defaultEnd = new Date();
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const parts = location.pathname;
  const user_data = useSelector((state) => state.user_data);
  console.log(userData, "410501");

  let pathname = parts?.trim()?.split("/");
  let businessId = pathname[2] || 0;

  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);

  const [formattedStart, setFormattedStart] = useState(
    moment(defaultStart).format("YYYY-MM-DD")
  );
  const [formattedEnd, setFormattedEnd] = useState(
    moment(defaultEnd).format("YYYY-MM-DD")
  );

  const formatDate = (date) => {
    if (!date) return "";
    return moment(date).format("YYYY-MM-DD");
  };
  console.log(userData, "check userData");
  const [uploadImage, setUploadImage] = useState(null);

  const [appoimentCount, setAppoimentCount] = useState(0);
  const [isServiceMenuOpen, setIsServiceMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isTeamOpen, setIsTeamOpen] = useState(false);


  const TeamFormValue = useSelector((state) => state.TeamValue);
  const formServiceValue = useSelector((state) => state.ServiceValue);

  const [uploadFile, setUploadFile] = useState(null);

  const MySwal = withReactContent(Swal);
  let route = all_routes;
  // const UserSource = useSelector((state) => state.user_data);

  // console.log(UserSource, "UserSource")

  // const route = all_routes;
  // const [chartOptions] = useState({
  //   series: [
  //     {
  //       name: "Sales",
  //       data: [130, 210, 300, 290, 150, 50, 210, 280, 105],
  //     },
  //     {
  //       name: "Purchase",
  //       data: [-150, -90, -50, -180, -50, -70, -100, -90, -105],
  //     },
  //   ],
  //   colors: ["#28C76F", "#EA5455"],
  //   chart: {
  //     type: "bar",
  //     height: 320,
  //     stacked: true,
  //     zoom: {
  //       enabled: true,
  //     },
  //   },
  //   responsive: [
  //     {
  //       breakpoint: 280,
  //       options: {
  //         legend: {
  //           position: "bottom",
  //           offsetY: 0,
  //         },
  //       },
  //     },
  //   ],
  //   plotOptions: {
  //     bar: {
  //       horizontal: false,
  //       borderRadius: 4,
  //       borderRadiusApplication: "end", // "around" / "end"
  //       borderRadiusWhenStacked: "all", // "all"/"last"
  //       columnWidth: "20%",
  //     },
  //   },
  //   dataLabels: {
  //     enabled: false,
  //   },
  //   yaxis: {
  //     min: -200,
  //     max: 300,
  //     tickAmount: 5,
  //   },
  //   xaxis: {
  //     categories: [
  //       "Jan",
  //       "Feb",
  //       "Mar",
  //       "Apr",
  //       "May",
  //       "Jun",
  //       "Jul",
  //       "Aug",
  //       "Sep",
  //     ],
  //   },
  //   legend: { show: false },
  //   fill: {
  //     opacity: 1,
  //   },
  // });
  // const MySwal = withReactContent(Swal);
  // const showConfirmationAlert = () => {
  //   MySwal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     showCancelButton: true,
  //     confirmButtonColor: "#00ff00",
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonColor: "#ff0000",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       MySwal.fire({
  //         title: "Deleted!",
  //         text: "Your file has been deleted.",
  //         className: "btn btn-success",
  //         confirmButtonText: "OK",
  //         customClass: {
  //           confirmButton: "btn btn-success",
  //         },
  //       });
  //     } else {
  //       MySwal.close();
  //     }
  //   });
  // };



  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/getBusinessAppoiments?startDate=${formattedStart}&endDate=${formattedEnd}`,
    });

    if (response.ResponseCode === "SUCCESS") {
      console.log(response?.ResponseData?.Appointments[0]?.TotalAppointments, "chec final responce")
      setAppoimentCount(response?.ResponseData?.Appointments[0]?.TotalAppointments)
    }

    const response1 = await apiHandler({
      method: "GET",
      route: `Superadmin/getinvoicedetailsbybusinessid?businessId=${userData?.businessId}`,
    });

    console.log(response1.ResponseData, "<=====check response1");
    if (response1?.ResponseData && Array.isArray(response1.ResponseData)) {
      setInvoices(response1.ResponseData);

      const res = await apiHandler({
        method: "POST",
        route: `stripe/checkinvoicepaymentstatus`,
        payload: {
          invoiceId: response1.ResponseData.filter((el) => el.Status !== "paid").map((el) => el.InvoiceId),
        },
      });

      console.log(res, "<=====check res");
    }
  };

  const handlePayInvoice = (invoiceLink) => {
    if (invoiceLink) {
      window.open(invoiceLink, "_blank", "noopener,noreferrer");
    }
  };




  useEffect(() => {
    prodcutDataListApi();
  }, [])


  const HandleServiceSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (
      formServiceValue?.serviceName == "" ||
      formServiceValue?.serviceType == 0 ||
      formServiceValue?.menuCategoryID == 0
    ) {
      let message = "";
      if (formServiceValue?.serviceName == "") {
        message = " Please Enter Service name ";
      } else if (formServiceValue?.serviceType == 0) {
        message = " Please select Service Type  ";
      } else if (formServiceValue?.menuCategoryID == 0) {
        message = " Please select Service Menu  ";
      }

      Swal.fire({
        position: "top-end",
        icon: "error",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    let priceDuration = formServiceValue?.Pricingandduration?.filter(
      (el) => el.Price > 0
    );

    let TeamDatavalue = formServiceValue?.Team?.filter(
      (el) => el.Ischecked == true
    );

    let priceDurationData = {};
    priceDurationData.PricinganddurationXml = priceDuration;
    let priceDurationDataString = JSON.stringify(priceDurationData);

    let TeamData = {};
    TeamData.TeamXml = TeamDatavalue;
    let TeamDataString = JSON.stringify(TeamData);

    const response = await apiHandler({
      method: "POST",
      route: "Business/businessServiceUpsert",
      payload: {
        ...formServiceValue,
        BusinessId: businessId,
        loginuserid: user_data.id,
        Pricingandduration: priceDurationDataString,
        Team: TeamDataString,
        files: uploadImage,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.ResponseCode === "SUCCESS") {
      setLoading(false);
      MySwal.fire({
        title: "Service Added!",
        text: "The Service has been successfully added.",
        className: "btn btn-success",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-success",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // navigate(route.ServiceList);
          setIsServicesOpen(false)
        }
      });
    } else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: `${response.ResponseMessage}`,
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const HandleTeamSubmit = async (e) => {
    e.preventDefault();

    if (
      TeamFormValue?.FirstName == "" ||
      TeamFormValue?.Email == "" ||
      (TeamFormValue?.ContactNumber &&
        !isValidAustralianPhoneNumber(TeamFormValue?.ContactNumber)) ||
      TeamFormValue?.RoleID == 0 ||
      TeamFormValue?.PassWord == "" ||
      TeamFormValue?.PassWord !== TeamFormValue.ConformPassword
    ) {
      let message = "";
      if (TeamFormValue?.FirstName == "") {
        message = " Please Enter Full Name  ";
      } else if (TeamFormValue?.Email == "") {
        message = " Please select Email  ";
      } else if (
        TeamFormValue?.ContactNumber &&
        !isValidAustralianPhoneNumber(TeamFormValue?.ContactNumber)
      ) {
        message = ` ${TeamFormValue?.ContactNumberError} `;
      } else if (TeamFormValue?.RoleID == 0) {
        message = " Please select RoleID ";
      } else if (TeamFormValue?.PassWord == "") {
        message = " Please Enter Valid  PassWord  ";
      } else if (TeamFormValue?.PassWord !== TeamFormValue.ConformPassword) {
        message = " Password and Confirm Password Must Be same   ";
      }

      Swal.fire({
        position: "top-end",
        icon: "error",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    let Emergencydata = {};
    Emergencydata.emergencyXml = TeamFormValue.EmergencyContact;
    let EmergencydataString = JSON.stringify(Emergencydata);
    let filterservice = TeamFormValue.Serviceandcommision?.filter(
      (el) => el.Ischecked == true
    );

    let ServiceData = {};
    ServiceData.serviceXml = filterservice;
    let ServiceDataString = JSON.stringify(ServiceData);

    setLoading(true);
    const response = await apiHandler({
      method: "POST",
      route: "Business/businessTeamUpsert",
      payload: {
        ...TeamFormValue,
        BusinessId: businessId,
        loginuserid: user_data.id,
        files: uploadFile,
        EmergencyContact: EmergencydataString,
        Serviceandcommision: ServiceDataString,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.ResponseCode === "SUCCESS") {
      setLoading(false);
      MySwal.fire({
        title: "Team Added!",
        text: "The Team has been successfully added.",
        className: "btn btn-success",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-success",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(setTeamValue(TeamData));
          setIsTeamOpen(false)
          // navigate(route.StaffListing);
        }
      });
      // navigate(route.BusinessListingMaster);
    } else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: `${response.ResponseMessage}`,
        showConfirmButton: false,
        timer: 1500,
      });
    }
    setLoading(false);
  };

  const handleTeamChangeFile = (file) => {
    setUploadFile(file);
  };

  if (!isAdmin) {
    return (
      <div>
        <LoadingSpinner isLoading={loading} />
        <div className="page-wrapper">
          <div className="content">
            <div className="welcome-non-admin-container d-flex align-items-center justify-content-center" style={{ minHeight: "65vh" }}>
              <div className="welcome-card text-center p-5 rounded-4 shadow-lg" style={{
                maxWidth: "680px",
                background: "linear-gradient(145deg, #ffffff, #fdf8fe)",
                border: "1px solid rgba(115, 62, 121, 0.12)",
                borderRadius: "20px",
                boxShadow: "0 15px 35px rgba(115, 62, 121, 0.05)"
              }}>
                <div className="welcome-icon-wrapper mb-4">
                  <div className="d-inline-flex align-items-center justify-content-center rounded-circle" style={{
                    width: "90px",
                    height: "90px",
                    backgroundColor: "rgba(115, 62, 121, 0.08)",
                    color: "#733e79"
                  }}>
                    <i className="fa fa-briefcase fa-3x welcome-icon-pulse"></i>
                  </div>
                </div>
                <h1 className="welcome-title fw-bold mb-3" style={{
                  color: "#733e79",
                  fontSize: "2.6rem",
                  letterSpacing: "-0.5px"
                }}>
                  Welcome to {userData?.businessUniqueName || "BookYarra"}
                </h1>
                <p className="welcome-text text-muted fs-5 mb-4" style={{
                  color: "#555555",
                  lineHeight: "1.6"
                }}>
                  Navigate through the sidebar to access system features and business operations. The options displayed are based on your assigned role and permissions.                </p>
                {/* <div className="welcome-badge d-inline-block px-4 py-2 rounded-pill fw-semibold" style={{
                  backgroundColor: "#733e79",
                  color: "#ffffff",
                  fontSize: "0.9rem",
                  boxShadow: "0 4px 10px rgba(115, 62, 121, 0.2)"
                }}>
                  Role: {userData?.roleName || "User"}
                </div> */}
              </div>
              <style>{`
                .welcome-card {
                  transition: transform 0.3s ease, box-shadow 0.3s ease;
                }
                .welcome-card:hover {
                  transform: translateY(-5px);
                  box-shadow: 0 20px 40px rgba(115, 62, 121, 0.1) !important;
                }
                .welcome-icon-pulse {
                  animation: iconPulse 2s infinite ease-in-out;
                }
                @keyframes iconPulse {
                  0%, 100% {
                    transform: scale(1);
                  }
                  50% {
                    transform: scale(1.08);
                  }
                }
              `}</style>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <LoadingSpinner isLoading={loading} />
      <div className="page-wrapper">
        {isServiceMenuOpen && (
          <ServiceMenuModal
            isOpen={isServiceMenuOpen}
            setIsOpen={setIsServiceMenuOpen}
            businessId={businessId}
            callBack={() => prodcutDataListApi()}

          />
        )}
        {isServicesOpen && (
          <div
            className={`modal d-block show`}
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Create Service</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsServicesOpen(false)}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <AddService
                    isFromOnboarding={1}
                    setUploadImage={setUploadImage}
                  />
                  <div className="content">
                    {/* <div className="row page-header justify-content-between">
                                  <div className="col-md-6"></div>
                                </div> */}
                    {/* Moved buttons to the end of .content */}

                    <div className="d-flex justify-content-end mb-4">
                      <button onClick={() => setIsServicesOpen(false)} className="btn btn-outline-primary btn-sm me-2">
                        Cancel
                      </button>
                      <button
                        onClick={HandleServiceSubmit}
                        className="8 btn btn-primary btn-md btn-wave me-2 "
                      >
                        Save
                        <ArrowRight />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {isTeamOpen && (
          <div
            className={`modal d-block show`}
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Create Team</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsTeamOpen(false)}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <AddTeam
                    handleChangeFile={handleTeamChangeFile}
                    isFromOnboarding={1}
                  />
                  <div className="col-md-12 p-4 d-flex justify-content-end">
                    <button
                      onClick={() => setIsTeamOpen(false)}
                      className="btn btn-primary btn-md btn-wave me-2"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={HandleTeamSubmit}
                      className="btn btn-outline-primary btn-md me-2"
                    >
                      Save
                      {/* <ArrowRight /> */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="content">
          <div className="text-center">
            <h2>BookYarra Dashboard</h2>
            {!isSuperAdmin && (
              <div className="row justify-content-center mt-4">
                <div className="col-12 col-xl-10">
                  <div className="card shadow-sm mb-4 rounded-4 overflow-hidden">
                    <div className="card-body p-4">
                      <div className="d-flex flex-column  gap-3 mb-4">
                        <div>
                          <h5 className="mb-1">Current Subscription Plan</h5>
                          <p className="text-muted mb-0">Your active plan details and renewal status.</p>
                        </div>
                      </div>
                      <div className="row g-3">
                        <div className="col-6 col-md-3">
                          <div className="bg-soft-primary rounded-3 p-3 h-100">
                            <small className="fw-bold fs-6">Plan Name</small>
                            <div className="fw-semibold fs-6 mt-2">
                              {userData?.planSubscriptionTemplateId === 4
                                ? "Free Trial"
                                : userData?.planSubscriptionName || userData?.planPlanName || "No active subscription"}
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-md-3">
                          <div className="bg-soft-primary rounded-3 p-3 h-100">
                            <small className="fw-bold fs-6">Subscription ID</small>
                            <div className="fw-semibold fs-6 mt-2">
                              {userData?.planSubscriptionTemplateId === 4
                                ? "Free"
                                : userData?.planStripeSubscriptionId || "Not available"}
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-md-3">
                          <div className="bg-soft-primary rounded-3 p-3 h-100">
                            <small className="fw-bold fs-6">Plan Type</small>
                            <div className="fw-semibold fs-6 mt-2">
                              {userData?.planSubscriptionTemplateId === 4
                                ? "Days"
                                : userData?.planPlanName || "-"}
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-md-3">
                          <div className="bg-soft-primary rounded-3 p-3 h-100">
                            <small className="fw-bold fs-6">Expiry</small>
                            <div className="fw-semibold fs-6 mt-2">
                              {userData?.planExpireDate
                                ? moment(userData.planExpireDate).isBefore(moment())
                                  ? "Expired"
                                  : moment(userData.planExpireDate).format("DD/MM/YYYY")
                                : "Not set"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {userData?.businessId === 0 && (
              <>
                <div className="row">
                  <div className="col-12 d-flex justify-content-center mt-4">
                    <Link to="/businessOnboarding" className="onboard-btn">
                      Onboard New Business
                    </Link>
                  </div>
                </div>

                <div className="d-flex justify-content-center mt-4">
                  <div className="card shadow p-4 rounded-4" style={{ maxWidth: "500px", width: "100%" }}>

                    {/* DATE FILTER ROW */}
                    <div
                      className="row mb-4"
                      style={{ position: "relative", zIndex: "" }}
                    >
                      {/* START DATE */}
                      <div className="col-md-6">
                        <label className="form-label mr-2">Start Date:</label>
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => {
                            setStartDate(date);
                            setFormattedStart(formatDate(date));
                          }}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          maxDate={endDate}
                        />
                      </div>

                      {/* END DATE */}
                      <div className="col-md-6">
                        <label className="form-label mr-2">End Date:</label>
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => {
                            setEndDate(date);
                            setFormattedEnd(formatDate(date));
                          }}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          minDate={startDate}
                        />
                      </div>
                    </div>

                    {/* TOTAL APPOINTMENTS */}
                    <div className="col-12 d-flex justify-content-center">
                      <span className="onboard-btn">
                        {appoimentCount} Total Appointments
                      </span>
                    </div>

                  </div>
                </div>


              </>


            )}

            <div className="d-flex justify-content-center flex-wrap flex-md-nowrap gap-3 mt-4">
              {!isSuperAdmin && (
                <Link
                  to={route.businessSubscription}
                  className="btn btn-primary d-flex align-items-center"
                  style={{ height: "40px" }}
                >
                  Subscription Plan
                </Link>
              )}
              {!isSuperAdmin && (
                <Link
                  to={route.BusinessOnboarding}
                  className="btn btn-primary d-flex align-items-center"
                  style={{ height: "40px" }}
                >
                  Business Profile
                </Link>
              )}
              <button
                style={{ height: "40px" }}
                type="button"
                className="d-flex align-items-center btn btn-primary"
                onClick={() => setIsServiceMenuOpen(true)}
              >
                Add Service Menu
              </button>
              <button
                style={{ height: "40px" }}
                type="button"
                className="d-flex align-items-center btn btn-primary"
                onClick={() => setIsServicesOpen(true)}
              >
                Add Services
              </button>
              <button
                style={{ height: "40px" }}
                type="button"
                className="d-flex align-items-center btn btn-primary"
                onClick={() => setIsTeamOpen(true)}
              >
                Add Team
              </button>
            </div>
          </div>

          {/* <div className="row">
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-widget w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="assets/img/icons/dash1.svg"
                      alt="img"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    <CountUp start={0} end={307144} duration={3} prefix="$" />
                  </h5>
                  <h6>Total Purchase Due</h6>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-widget dash1 w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="assets/img/icons/dash2.svg"
                      alt="img"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <CountUp
                      start={0}
                      end={4385}
                      duration={3} // Duration in seconds
                    />
                  </h5>
                  <h6>Total Sales Due</h6>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-widget dash2 w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="assets/img/icons/dash3.svg"
                      alt="img"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <CountUp
                      start={0}
                      end={385656.5}
                      duration={3} // Duration in seconds
                      decimals={1}
                    />
                  </h5>
                  <h6>Total Sale Amount</h6>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-widget dash3 w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="assets/img/icons/dash4.svg"
                      alt="img"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <CountUp
                      start={0}
                      end={40000}
                      duration={3} // Duration in seconds
                    />
                  </h5>
                  <h6>Total Expense Amount</h6>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-count">
                <div className="dash-counts">
                  <h4>100</h4>
                  <h5>Customers</h5>
                </div>
                <div className="dash-imgs">
                  <User />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-count das1">
                <div className="dash-counts">
                  <h4>110</h4>
                  <h5>Suppliers</h5>
                </div>
                <div className="dash-imgs">
                  <UserCheck />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-count das2">
                <div className="dash-counts">
                  <h4>150</h4>
                  <h5>Purchase Invoice</h5>
                </div>
                <div className="dash-imgs">
                  <ImageWithBasePath
                    src="assets/img/icons/file-text-icon-01.svg"
                    className="img-fluid"
                    alt="icon"
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-count das3">
                <div className="dash-counts">
                  <h4>170</h4>
                  <h5>Sales Invoice</h5>
                </div>
                <div className="dash-imgs">
                  <File />
                </div>
              </div>
            </div>
          </div> */}
          {/* Button trigger modal */}

          {/* <div className="row">
            <div className="col-xl-7 col-sm-12 col-12 d-flex">
              <div className="card flex-fill">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Purchase &amp; Sales</h5>
                  <div className="graph-sets">
                    <ul className="mb-0">
                      <li>
                        <span>Sales</span>
                      </li>
                      <li>
                        <span>Purchase</span>
                      </li>
                    </ul>
                    <div className="dropdown dropdown-wraper">
                      <button
                        className="btn btn-light btn-sm dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        2023
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <li>
                          <Link to="#" className="dropdown-item">
                            2023
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="dropdown-item">
                            2022
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="dropdown-item">
                            2021
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div id="sales_charts" />
                  <Chart
                    options={chartOptions}
                    series={chartOptions.series}
                    type="bar"
                    height={320}
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-sm-12 col-12 d-flex">
              <div className="card flex-fill default-cover mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0">Recent Products</h4>
                  <div className="view-all-link">
                    <Link to="#" className="view-all d-flex align-items-center">
                      View All
                      <span className="ps-2 d-flex align-items-center">
                        <ArrowRight className="feather-16" />
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive dataview">
                    <table className="table dashboard-recent-products">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Products</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td className="productimgname">
                            <Link
                              to={route.productlist}
                              className="product-img"
                            >
                              <ImageWithBasePath
                                src="assets/img/products/stock-img-01.png"
                                alt="product"
                              />
                            </Link>
                            <Link to={route.productlist}>
                              Lenevo 3rd Generation
                            </Link>
                          </td>
                          <td>$12500</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td className="productimgname">
                            <Link
                              to={route.productlist}
                              className="product-img"
                            >
                              <ImageWithBasePath
                                src="assets/img/products/stock-img-06.png"
                                alt="product"
                              />
                            </Link>
                            <Link to={route.productlist}>Bold V3.2</Link>
                          </td>
                          <td>$1600</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td className="productimgname">
                            <Link
                              to={route.productlist}
                              className="product-img"
                            >
                              <ImageWithBasePath
                                src="assets/img/products/stock-img-02.png"
                                alt="product"
                              />
                            </Link>
                            <Link to={route.productlist}>Nike Jordan</Link>
                          </td>
                          <td>$2000</td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td className="productimgname">
                            <Link
                              to={route.productlist}
                              className="product-img"
                            >
                              <ImageWithBasePath
                                src="assets/img/products/stock-img-03.png"
                                alt="product"
                              />
                            </Link>
                            <Link to={route.productlist}>
                              Apple Series 5 Watch
                            </Link>
                          </td>
                          <td>$800</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="card">
            <div className="card-header">
              <h4 className="card-title">Expired Products</h4>
            </div>
            <div className="card-body">
              <div className="table-responsive dataview">
                <table className="table dashboard-expired-products">
                  <thead>
                    <tr>
                      <th className="no-sort">
                        <label className="checkboxs">
                          <input type="checkbox" id="select-all" />
                          <span className="checkmarks" />
                        </label>
                      </th>
                      <th>Product</th>
                      <th>SKU</th>
                      <th>Manufactured Date</th>
                      <th>Expired Date</th>
                      <th className="no-sort">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <div className="productimgname">
                          <Link to="#" className="product-img stock-img">
                            <ImageWithBasePath
                              src="assets/img/products/expire-product-01.png"
                              alt="product"
                            />
                          </Link>
                          <Link to="#">Red Premium Handy </Link>
                        </div>
                      </td>
                      <td>
                        <Link to="#">PT006</Link>
                      </td>
                      <td>17 Jan 2023</td>
                      <td>29 Mar 2023</td>
                      <td className="action-table-data">
                        <div className="edit-delete-action">
                          <Link className="me-2 p-2" to="#">
                            <i data-feather="edit" className="feather-edit" />
                          </Link>
                          <Link
                            className=" confirm-text p-2"
                            to="#"
                            onClick={showConfirmationAlert}
                          >
                            <i
                              data-feather="trash-2"
                              className="feather-trash-2"
                            />
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <div className="productimgname">
                          <Link to="#" className="product-img stock-img">
                            <ImageWithBasePath
                              src="assets/img/products/expire-product-02.png"
                              alt="product"
                            />
                          </Link>
                          <Link to="#">Iphone 14 Pro</Link>
                        </div>
                      </td>
                      <td>
                        <Link to="#">PT007</Link>
                      </td>
                      <td>22 Feb 2023</td>
                      <td>04 Apr 2023</td>
                      <td className="action-table-data">
                        <div className="edit-delete-action">
                          <Link className="me-2 p-2" to="#">
                            <i data-feather="edit" className="feather-edit" />
                          </Link>
                          <Link
                            className="confirm-text p-2"
                            to="#"
                            onClick={showConfirmationAlert}
                          >
                            <i
                              data-feather="trash-2"
                              className="feather-trash-2"
                            />
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <div className="productimgname">
                          <Link to="#" className="product-img stock-img">
                            <ImageWithBasePath
                              src="assets/img/products/expire-product-03.png"
                              alt="product"
                            />
                          </Link>
                          <Link to="#">Black Slim 200 </Link>
                        </div>
                      </td>
                      <td>
                        <Link to="#">PT008</Link>
                      </td>
                      <td>18 Mar 2023</td>
                      <td>13 May 2023</td>
                      <td className="action-table-data">
                        <div className="edit-delete-action">
                          <Link className="me-2 p-2" to="#">
                            <i data-feather="edit" className="feather-edit" />
                          </Link>
                          <Link
                            className=" confirm-text p-2"
                            to="#"
                            onClick={showConfirmationAlert}
                          >
                            <i
                              data-feather="trash-2"
                              className="feather-trash-2"
                            />
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <div className="productimgname">
                          <Link to="#" className="product-img stock-img">
                            <ImageWithBasePath
                              src="assets/img/products/expire-product-04.png"
                              alt="product"
                            />
                          </Link>
                          <Link to="#">Woodcraft Sandal</Link>
                        </div>
                      </td>
                      <td>
                        <Link to="#">PT009</Link>
                      </td>
                      <td>29 Mar 2023</td>
                      <td>27 May 2023</td>
                      <td className="action-table-data">
                        <div className="edit-delete-action">
                          <Link className="me-2 p-2" to="#">
                            <i data-feather="edit" className="feather-edit" />
                          </Link>
                          <Link
                            className=" confirm-text p-2"
                            to="#"
                            onClick={showConfirmationAlert}
                          >
                            <i
                              data-feather="trash-2"
                              className="feather-trash-2"
                            />
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                        </label>
                      </td>
                      <td>
                        <div className="productimgname">
                          <Link to="#" className="product-img stock-img">
                            <ImageWithBasePath
                              src="assets/img/products/stock-img-03.png"
                              alt="product"
                            />
                          </Link>
                          <Link to="#">Apple Series 5 Watch </Link>
                        </div>
                      </td>
                      <td>
                        <Link to="#">PT010</Link>
                      </td>
                      <td>24 Mar 2023</td>
                      <td>26 May 2023</td>
                      <td className="action-table-data">
                        <div className="edit-delete-action">
                          <Link
                            className="me-2 p-2"
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#edit-units"
                          >
                            <i data-feather="edit" className="feather-edit" />
                          </Link>
                          <Link
                            className=" confirm-text p-2"
                            to="#"
                            onClick={showConfirmationAlert}
                          >
                            <i
                              data-feather="trash-2"
                              className="feather-trash-2"
                            />
                          </Link>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div> */}
          {/* ── Invoice Section ── */}
          {invoices.length > 0 && (
            <div className="row mt-4">
              <div className="col-12">
                <div className="card shadow-sm">
                  <div
                    className="card-header d-flex align-items-center justify-content-between"
                    style={{
                      background: " #733e79 ",
                      borderRadius: "8px 8px 0 0",
                    }}
                  >
                    <h5 className="mb-0 text-white">
                      <i className="fa fa-file-invoice me-2" />
                      Subscription Invoices
                    </h5>
                    <span className="badge bg-light text-dark">
                      {invoices.length} Invoice{invoices.length !== 1 ? "s" : ""}
                    </span>
                  </div>

                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-hover mb-0">
                        <thead style={{ backgroundColor: "#ffffffff" }}>
                          <tr>
                            <th className="ps-3">#</th>
                            <th>Invoice ID</th>
                            <th>Customer Stripe ID</th>
                            <th className="text-center">Amount</th>
                            <th className="text-center">Status</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invoices.map((inv, index) => {
                            const isPending =
                              String(inv.Status).toLowerCase() === "open" || String(inv.Status).toLowerCase() === "pending";
                            const isPaid =
                              String(inv.Status).toLowerCase() === "paid";
                            return (
                              <tr key={inv.ID || index}>
                                <td className="ps-3 align-middle text-muted">
                                  {index + 1}
                                </td>
                                <td className="align-middle">
                                  <span
                                    className="text-truncate d-inline-block"
                                    style={{ maxWidth: "200px" }}
                                    title={inv.InvoiceId}
                                  >
                                    {inv.InvoiceId}
                                  </span>
                                </td>
                                <td className="align-middle">
                                  <span
                                    className="text-truncate d-inline-block"
                                    style={{ maxWidth: "160px" }}
                                    title={inv.Customer_stripe_Id}
                                  >
                                    {inv.Customer_stripe_Id}
                                  </span>
                                </td>
                                <td className="text-center align-middle">
                                  ${(inv.commissionAmount).toFixed(2)}
                                </td>
                                <td className="text-center align-middle">
                                  {isPending && (
                                    <span
                                      className="badge"
                                      style={{
                                        background: "#ffffffff",
                                        color: "#733e79",
                                        border: "1px solid #733e79",
                                        fontSize: "12px",
                                        padding: "5px 10px",
                                      }}
                                    >
                                      <i className="fa fa-clock me-1" />
                                      Pending
                                    </span>
                                  )}
                                  {isPaid && (
                                    <span
                                      className="badge"
                                      style={{
                                        background: "#ffffffff",
                                        color: "#733e79",
                                        border: "1px solid #733e79",
                                        fontSize: "12px",
                                        padding: "5px 10px",
                                      }}
                                    >
                                      <i className="fa fa-check-circle me-1" />
                                      Paid
                                    </span>
                                  )}
                                  {!isPending && !isPaid && (
                                    <span className="badge bg-secondary">
                                      {inv.Status}
                                    </span>
                                  )}
                                </td>
                                <td className="text-center align-middle">
                                  {
                                    <>



                                      <button
                                        className="btn btn-primary"

                                        onClick={() =>
                                          handlePayInvoice(inv.InvoiceLink)
                                        }
                                      >
                                        <i className="fa fa-credit-card me-1" />
                                        Pay Now
                                      </button>

                                      <button
                                        className="btn btn-secondary m-2"
                                        onClick={() => Navigate(`${route.InvoiceDetail}/${inv.ID}`)}

                                      >
                                        <i className="fa fa-eye me-1" />
                                        View
                                      </button>
                                    </>
                                  }
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
